import React from 'react';
import { Button, Text } from 'src/@vymo/ui/atoms';
import Accordion from 'src/@vymo/ui/blocks/accordion';
import { setFilters } from 'src/models/filters/slice';
import { REVYRE_WORKFLOW_LIST } from 'src/modules/constants';
import { useAppDispatch } from 'src/store/hooks';
import { renderModule } from 'src/workspace/slice';
import { CASE } from '../../constant';
import ActiveCases from './active';
import SuspendedCases from './suspended';
import styles from '../../index.module.scss';

function Cases(props) {
  const { module, entityId } = props;
  const dispatch = useAppDispatch();

  return (
    <Accordion
      title={
        <div className={styles.detailsWrapper__detailsBody__cases__title}>
          {module.flowName}{' '}
          <Button
            variant="subtle"
            size="small"
            onClick={(e) => {
              e.preventDefault();
              const filterContext = `revyre_${CASE}_default`;
              dispatch(
                setFilters({
                  context: filterContext,
                  filters: { [module.key || 'lan']: entityId },
                }),
              );
              dispatch(
                renderModule({
                  id: REVYRE_WORKFLOW_LIST,
                  props: {
                    domainType: 'workflow',
                    workflowType: CASE,
                  },
                }),
              );
            }}
          >
            {' '}
            View All
          </Button>
        </div>
      }
      type="subtle"
      open
      className={styles.detailsWrapper__detailsBody__relatedRecords__accordion}
    >
      <div className={styles.detailsWrapper__detailsBody__cases}>
        <Text type="h6">Active</Text>
        <ActiveCases module={{ ...module, entityId, code: 'activeCases' }} />
        <Text type="h6">Suspended</Text>
        <SuspendedCases
          module={{ ...module, entityId, code: 'suspendedCases' }}
        />
      </div>
    </Accordion>
  );
}

export default Cases;
